;(function () {
    const comps = document.querySelectorAll('.m-flex-bloc-avant-apres');
    if (!comps || !comps.length) return;

    comps.forEach(comp => {
        const apres = comp.querySelector('.m-flex-bloc-avant-apres__apres');
        const slider = comp.querySelector('.m-flex-bloc-avant-apres__slider');
        
        let isDragging = false;

        function updatePosition(x) {
            const rect = comp.getBoundingClientRect();
            let percent = ((x - rect.left) / rect.width) * 100;
            
            percent = Math.max(0, Math.min(100, percent));
            
            apres.style.clipPath = `inset(0 0 0 ${percent}%)`;
            slider.style.left = `${percent}%`;
        }

        // Mouse events
        comp.addEventListener('mousedown', (e) => {
            e.preventDefault(); // Empêche le drag natif
            isDragging = true;
            updatePosition(e.clientX);
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            e.preventDefault();
            updatePosition(e.clientX);
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
        });

        // Touch events
        comp.addEventListener('touchstart', (e) => {
            isDragging = true;
            updatePosition(e.touches[0].clientX);
        });

        document.addEventListener('touchmove', (e) => {
            if (!isDragging) return;
            updatePosition(e.touches[0].clientX);
        });

        document.addEventListener('touchend', () => {
            isDragging = false;
        });

        // Empêcher le drag natif sur tout le composant
        comp.addEventListener('dragstart', (e) => {
            e.preventDefault();
        });
    });
}());